import Model from "./model";
import TextDecorationParams from "../api/model/snapshots/layers/TextDecoration";

export default class TextDecoration extends Model {
    underline?: boolean;
    strikethrough?: boolean;

    constructor(params: TextDecorationParams) {
        super();
        this.underline = params.underline;
        this.strikethrough = params.strikethrough;
    }

    override toObject() {
        return {
            underline: this.underline,
            strikethrough: this.strikethrough
        };
    }
}
